import type { ChannelNameWithParams, Consumer, Mixin, Subscription } from '@rails/actioncable';

// Subscribes to a channel on the page's consumer (window.cable).
// Use the returned unsubscribe() instead of subscription.unsubscribe(): when the server rejects the subscription
// (e.g. a UserChannel for an anonymous visitor), the client forgets it, but subscription.unsubscribe() still sends
// an "unsubscribe" command, and the server logs "Unable to find subscription" for it.
export const subscribe = (
  channel: ChannelNameWithParams,
  mixin: Mixin
): { subscription: Subscription; unsubscribe: () => void } => {
  let rejected = false;
  const subscription = (window.cable as Consumer).subscriptions.create(channel, {
    ...mixin,
    rejected(this: Subscription) {
      rejected = true;
      mixin.rejected?.call(this);
    },
  });

  const unsubscribe = () => {
    if (!rejected) subscription.unsubscribe();
  };

  return { subscription, unsubscribe };
};
